import { Box, Container, Grid, Group, Pagination, Select } from "@mantine/core";
import { useState } from "react";
import GridItem from "./GridItem/GridItem";
import { useEffect } from "react";
import { GridPageType, ProductData, SubsData } from "../../types/types";
import forestWaterfallImg from "../../assets/img/forest-waterfall.jpg";
import subProdBg from "../../assets/img/subProdBg.jpg";
import mySubBg from "../../assets/img/mySubBg.jpg";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { useFilterReset } from "../TableSort/FilterGroup/FilterResetContext";

export function GridAsymmetrical({ type }: { type: GridPageType }) {
  const [loading, setLoading] = useState(true);
  const [subsItems, setSubsItems] = useState<SubsData[]>([]);
  const [productItems, setProductItems] = useState<ProductData[]>([]);
  const isSubscription = type === "subscriptions";
  const { resetKey } = useFilterReset();
  const [activePage, setPage] = useState(1);
  const pageSizeOptions = ["5", "10", "20", "50"];
  const [pageSize, setPageSize] = useState(5);
  const start = (activePage - 1) * pageSize;
  const end = start + pageSize;
  let paginatedSubData: SubsData[] = [];
  let paginatedProdData: ProductData[] = [];

  function handlePageSizeChange(value: any, totalItems: number) {
    const newSize = parseInt(value, 10);
    const newTotalPages = Math.ceil(totalItems / newSize);
    // Reset to page 1 if current page exceeds new total pages
    setPage(Math.min(activePage, newTotalPages));
    setPageSize(newSize);
  }

  if (type === "subscriptions") {
    paginatedSubData = subsItems.slice(start, end);
  } else if (type === "products") {
    paginatedProdData = productItems.slice(start, end);
  }

  useEffect(() => {
    async function fetchGridItems() {
      try {
        setLoading(!false); // fok u Luke
        setLoading(true); // You're welcome Alex :)
        const response = await fetch(
          window.location.origin + "/server/client_service/" + type
        );
        const resData = await response.json();
        console.log("Res data is", resData);

        if (!response.ok) {
          throw new Error("Failed to fetch items");
        }
        setLoading(false);
        if (isSubscription) {
          setSubsItems(resData);
        } else {
          setProductItems(resData);
        }
        // reset page size on trigger reset of navbar click
        setPageSize(5);
      } catch (error) {
        console.log(error);
      }
    }

    fetchGridItems();
  }, [type, resetKey]);

  return (
    <Container my="md" h="85vh">
      {loading ? (
        <LoadingSpinner size="lg" color="blue" />
      ) : (
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {type === "subscriptions" ? (
            <>
              <Box style={{ flex: 1 }}>
                <Grid>
                  {paginatedSubData.map((item) => (
                    <Grid.Col
                      key={item.Subscription_Number}
                      span={{ base: 12, xs: 4 }}
                    >
                      <GridItem
                        type="subscriptions"
                        data={item}
                        image={{
                          src: mySubBg,
                          alt: "Light blue abstract background",
                        }}
                      ></GridItem>
                    </Grid.Col>
                  ))}
                </Grid>
              </Box>
              <Group justify="apart" align="center" mt="md">
                <Group gap="xs" style={{ marginTop: "2vh" }}>
                  <Select
                    data={pageSizeOptions}
                    value={pageSize.toString()}
                    onChange={(value) =>
                      handlePageSizeChange(value, subsItems.length)
                    }
                    w={100}
                  />
                </Group>
                <Pagination
                styles={{
    control: {
      '&[data-active]': {
        backgroundImage: 'linear-gradient(90deg, #228be6, #d0ebff)', // same as Button gradient
        color: 'white',
        border: 'none',
      },
    },
  }}
                  total={Math.ceil(subsItems.length / pageSize)}
                  value={activePage}
                  onChange={setPage}
                  mt="md"
                />
              </Group>
            </>
          ) : (
            <>
              <Box style={{ flex: 1 }}>
                <Grid>
                  {paginatedProdData.map((item) => (
                    <Grid.Col key={item.Product_Id} span={{ base: 12, xs: 4 }}>
                      <GridItem
                        type="products"
                        data={item}
                        image={{
                          src: subProdBg,
                          alt: "Abstract blue background",
                        }}
                      ></GridItem>
                    </Grid.Col>
                  ))}
                </Grid>
              </Box>
              <Group justify="apart" align="center">
                <Group gap="xs" style={{ marginTop: "2vh" }}>
                  <Select
                    data={pageSizeOptions}
                    value={pageSize.toString()}
                    onChange={(value) =>
                      handlePageSizeChange(value, productItems.length)
                    }
                    w={100}
                  />
                </Group>
                <Pagination
                  total={Math.ceil(productItems.length / pageSize)}
                  value={activePage}
                  onChange={setPage}
                  mt="md"
                />
              </Group>
            </>
          )}
        </Box>
      )}
    </Container>
  );
}
